var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32143 9V12H19.6786V9C19.6786 6.2375 17.3612 4 14.5 4C11.6388 4 9.32143 6.2375 9.32143 9ZM5.17857 12V9C5.17857 4.03125 9.35379 0 14.5 0C19.6462 0 23.8214 4.03125 23.8214 9V12H24.8571C27.1422 12 29 13.7937 29 16V28C29 30.2062 27.1422 32 24.8571 32H4.14286C1.85781 32 0 30.2062 0 28V16C0 13.7937 1.85781 12 4.14286 12H5.17857Z",
    fill: "#233C7E",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.67e42e7cc203e33349113aadf417b21c.svg";
export { ForwardRef as ReactComponent };